import './MainContent.scss'

import PropTypes from 'prop-types'
import React from 'react'

export default function MainContent({ main, aside }) {
  return (
    <div className="main-content">
      <main>{main}</main>
      <aside>{aside}</aside>
    </div>
  )
}

MainContent.propTypes = {
  aside: PropTypes.node,
  main: PropTypes.node
}
